<div class="table-container">
  @if (transactions) {
    <p-table [value]="transactions.data">
      <ng-template pTemplate="header">
        <tr>
          <th>Data</th>
          <th>Hora</th>
          <th>Transação</th>
          <th>Valor</th>
          <th>Origem</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-transaction>
        <tr>
          <td>{{ transaction.created_at | date: "shortDate" }}</td>
          <td>{{ transaction.created_at | date: "HH:mm" }}</td>
          <td>{{ transaction.transaction_type | transactionTypeEnum }}</td>
          <td [class.account-statement__amount--debit]="isDebit(transaction.transaction_type)">
            {{ signedAmount(transaction) | currency: "BRL" }}
          </td>
          <td>{{ transaction.description }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5">Você ainda não possui nenhum extrato.</td>
        </tr>
      </ng-template>
    </p-table>
    <p-paginator
      (onPageChange)="handlePageChange($event)"
      [first]="first"
      [rows]="rows"
      [totalRecords]="transactions.meta.total_count"
      [showCurrentPageReport]="false"
      [showPageLinks]="false"
      [showJumpToPageDropdown]="false"
      [rowsPerPageOptions]="[10, 20, 30]"
      currentPageReportTemplate="Mostrando {first} até {last} de {totalRecords}" />
  } @else {
    <p-skeleton height="300px" />
  }
</div>
